import type { MentionRow } from './generator';

/**
 * The brand this product belongs to.
 *
 * Every module is a view of **our** brand — "how are we doing" is the default
 * question everywhere. Competitors is the single exception, and the only place
 * a cross-brand figure is meaningful.
 *
 * This is why there is no Brands chip outside Competitors: the chip declares
 * `types: ['competitors']` in the filter fixtures, so `FiltersBar` already
 * hides it everywhere else. Scoping the *rows* here is the other half of the
 * same rule — without it a module would draw every brand's data under a bar
 * with no brand selector, which reads as our own numbers and is not.
 *
 * The value is the fixture's slug, not its label: `opts()` lowercases and
 * hyphenates, so `Grameenphone` is stored as `grameenphone`.
 */
export const USER_BRAND = 'grameenphone';

/** Rows for our own brand. The first step of every non-Competitors query. */
export function ownBrand(rows: readonly MentionRow[]): readonly MentionRow[] {
  return rows.filter((row) => row.brand === USER_BRAND);
}
